export enum DsProjectStatusEnum {
  completed = 'completed',
  archived = 'archived',
  waiting = 'waiting',
  ongoing = 'ongoing',
  failed = 'failed',
}
